export const isString = <T>(str: T | string): str is string =>
  typeof str === 'string' && typeof str.endsWith === 'function';

export const ellipsize = (str?: string, max = 100) =>
  str ? (str.length <= max ? str : `${str.substring(0, max - 1)}…`) : '';

export const capitalize = (str: string) =>
  str.toLowerCase().replace(/^[a-z]/i, firstLetter => firstLetter.toUpperCase());

export const isNonEmptyString = <T>(str: T | string): str is string =>
  isString(str) && str.length > 0;

export const isEmptyString = <T>(str: T | string): str is '' => isString(str) && str.length === 0;

export const ellipsizeMiddle = (
  str: string,
  { keepLeadingChars, keepTrailingChars } = { keepLeadingChars: 4, keepTrailingChars: 4 },
) => {
  if (str.length <= keepLeadingChars + keepTrailingChars) return str;

  const start = str.slice(0, keepLeadingChars);
  const end = str.slice(-keepTrailingChars);

  return `${start} … ${end}`;
};

export const formatFirstLetterToUpperCase = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const isNumeric = (value: unknown): value is string => {
  if (!isString(value)) return false;
  const trimmed = value.trim();
  // This regex covers:
  // - An optional sign (+ or -)
  // - Either:
  //    • one or more digits optionally followed by a decimal part, or
  //    • a decimal point followed by one or more digits
  // - An optional exponential part (e.g., e+10)
  const numericPattern = /^[-+]?(\d+(\.\d*)?|\.\d+)([eE][-+]?\d+)?$/;
  return isNonEmptyString(trimmed) && numericPattern.test(trimmed);
};
